import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { isPaidUserSelector } from '~/src/Auth/store';

const year = new Date().getFullYear();

const styles = makeStyles(({ palette }) => ({
  footerButtonStyle: {
    textDecoration: 'none',
    color: palette.custom.darkText,
    '&:hover': {
      color: palette.secondary.main,
    },
  },
  squarkLinkStyle: {
    color: palette.custom.darkText,
    '&:hover': {
      color: palette.secondary.main,
    },
  },
  containerStyle: {
    gap: '16px',
    display: 'flex',
    alignItems: 'center',
  },
}));

const Footer = () => {
  const { t } = useTranslation('layout');
  const isPaid = useRecoilValue(isPaidUserSelector);
  const { footerButtonStyle, squarkLinkStyle, containerStyle } = styles();

  return (
    <Box pl={8} pr={10} pb={3}>
      <Box mb={3}>
        <Divider />
      </Box>
      <Box className={containerStyle}>
        <a
          href="https://www.squarkai.com/terms-of-service/"
          className={footerButtonStyle}
        >
          <Typography variant="body2">{t('footer.terms')}</Typography>
        </a>
        <a
          href="https://www.squarkai.com/privacy-policy/"
          className={footerButtonStyle}
        >
          <Typography variant="body2">{t('footer.privacy')}</Typography>
        </a>
        <a href="https://www.squarkai.com/about/" className={footerButtonStyle}>
          <Typography variant="body2">{t('footer.about')}</Typography>
        </a>
        <Link to="/api-keys" className={footerButtonStyle}>
          <Typography variant="body2">{t('footer.develop')}</Typography>
        </Link>
        <Link to="/mcp" className={footerButtonStyle}>
          <Typography variant="body2">{t('footer.mcp')}</Typography>
        </Link>
        <Box mx={4} flex="auto" />
        {!isPaid && (
          <>
            <Box>
              <Typography variant="body2" color="textSecondary">
                {t('footer.free')}
                <a
                  href="https://squarkai.com/eula"
                  target="_blank"
                  className={squarkLinkStyle}
                >
                  squarkai.com/eula
                </a>
              </Typography>
            </Box>
            <Box mx={4} flex="auto" />
          </>
        )}
        <Typography variant="body2" color="textSecondary">
          {t('footer.copyright', { year })}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
